
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import 'lodash/isEqual';
import 'just-kebab-case';
import './labels-mixin.js';
import 'focus-visible/dist/focus-visible.js';
import { _ as _objectSpread } from './_rollupPluginBabelHelpers-mixin.js';
import kebabCase from 'lodash/kebabCase';
import 'feather-icons';
import './pendo-icon.js';
import 'vue';
import 'lodash/get';
import './pendo-loading-mixin.js';
import './pendo-loading-indicator.js';
import PendoButton from './pendo-button.js';
import './collapse-transition-mixin.js';
import 'color';
import 'color-string';
import './color-picker-helper-mixin.js';
import PendoTag from './pendo-tag.js';
import 'v-tooltip';
import './tooltip-mixin.js';
import PendoTooltip from './pendo-tooltip.js';
import PendoCard from './pendo-card.js';
import './pendo-divider.js';
import 'lodash/isNumber';
import { l as elementHasOverflowX } from './table-auto-height-mixin.js';
import 'element-ui/lib/dialog';
import 'resize-observer-polyfill';
import PendoModal from './pendo-modal.js';
import PendoPopover from './pendo-popover.js';
import 'vue-observe-visibility';
import PendoChooserGrid from './pendo-chooser-grid.js';
import PendoLayoutPreview from './pendo-layout-preview.js';

var script = {
  name: 'PendoLayoutGrid',
  components: {
    PendoCard,
    PendoChooserGrid,
    PendoLayoutPreview,
    PendoButton,
    PendoModal,
    PendoTag,
    PendoPopover
  },
  directives: {
    PendoTooltip
  },
  inheritAttrs: false,
  props: {
    title: {
      type: String,
      default: null
    },
    layouts: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    allowActions: {
      type: Object,
      default: () => ({})
    },
    filters: {
      type: [Object, Array],
      default: () => [{
        prop: ['title', 'subtitle'],
        value: ''
      }]
    },
    collapsible: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      showDeleteLayoutModal: false,
      layoutToDelete: null,
      selectedLayout: null,
      dataCy: kebabCase(`${this.title} Layouts`),
      titleTooltipContent: null
    };
  },

  computed: {
    formattedLayouts() {
      const loading = this.loading,
            layouts = this.layouts,
            disabled = this.disabled,
            selectedLayout = this.selectedLayout;

      if (loading && !layouts.length) {
        return Array(8).fill({
          disabled: true,
          loading: true
        });
      }

      return layouts.map(layout => {
        const id = layout.id || kebabCase(layout.name);
        return _objectSpread({}, layout, {
          id,
          title: layout.name,
          subtitle: layout.subtext || 'Pendo Default',
          disabled: loading || layout.loading || disabled || !layout.active,
          loading: loading || layout.loading,
          selected: selectedLayout ? selectedLayout.id === id : false,
          tooltipOptions: _objectSpread({}, layout.tooltipOptions, {
            content: layout.active ? null : layout.tooltipOptions && layout.tooltipOptions.content
          })
        });
      });
    }

  },

  mounted() {
    this.checkTitleOverflow();
  },

  methods: {
    async checkTitleOverflow() {
      const elementHasOverflow = elementHasOverflowX(this.$refs.title);

      if (elementHasOverflow) {
        this.titleTooltipContent = this.title;
      }
    },

    handleLayoutSelect(layout) {
      this.selectedLayout = layout;
      this.$emit('select-layout', layout);
      this.$emit('onChooseLayout', layout);
    },

    handleLayoutDelete(layout) {
      this.layoutToDelete = layout;
      this.showDeleteLayoutModal = true;
    },

    cancelDelete() {
      this.layoutToDelete = null;
      this.showDeleteLayoutModal = false;
    },

    confirmDelete() {
      this.$emit('delete-layout', this.layoutToDelete);
      this.$emit('onDeleteLayout', this.layoutToDelete);
      this.layoutToDelete = null;
      this.showDeleteLayoutModal = false;
    }

  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('pendo-card', {
    staticClass: "pendo-layout-grid",
    attrs: {
      "title": _vm.title,
      "data-cy": _vm.dataCy,
      "collapsible": _vm.collapsible,
      "disabled": _vm.disabled
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_c('div', {
          staticClass: "pendo-layout-grid__title-wrapper"
        }, [_c('div', {
          directives: [{
            name: "pendo-tooltip",
            rawName: "v-pendo-tooltip",
            value: {
              content: _vm.titleTooltipContent,
              arrow: true,
              html: false,
              delay: {
                show: 300,
                hide: 0
              }
            },
            expression: "{ content: titleTooltipContent, arrow: true, html: false, delay: { show: 300, hide: 0 } }"
          }],
          ref: "title",
          staticClass: "pendo-layout-grid__title"
        }, [_vm._v("\n                " + _vm._s(_vm.title) + "\n            ")]), _vm._v(" "), _c('div', {
          staticClass: "pendo-layout-grid__layouts-text"
        }, [_vm._v("\n                 Layouts\n            ")])])];
      },
      proxy: true
    }])
  }, [_vm._v(" "), _vm._t("beforeLayouts"), _vm._v(" "), _c('pendo-chooser-grid', {
    attrs: {
      "value": _vm.selectedLayout,
      "disabled": _vm.disabled,
      "items": _vm.formattedLayouts,
      "filters": _vm.filters
    },
    on: {
      "select": _vm.handleLayoutSelect
    },
    scopedSlots: _vm._u([{
      key: "media",
      fn: function (ref) {
        var item = ref.item;
        return [!item.loading ? _c('pendo-layout-preview', {
          attrs: {
            "layout": item
          }
        }) : _vm._e()];
      }
    }, {
      key: "overlay",
      fn: function (ref) {
        var item = ref.item;
        var select = ref.select;
        return [_vm.allowActions.delete && !item.readOnly ? _c('pendo-button', {
          directives: [{
            name: "pendo-tooltip",
            rawName: "v-pendo-tooltip",
            value: {
              content: 'Delete Layout',
              offset: 0,
              delay: {
                show: 300,
                hide: 0
              }
            },
            expression: "{ content: 'Delete Layout', offset: 0, delay: { show: 300, hide: 0 } }"
          }],
          staticClass: "delete-layout",
          attrs: {
            "data-cy": "delete-layout",
            "icon": "trash-2",
            "icon-size": "18"
          },
          on: {
            "click": function ($event) {
              return _vm.handleLayoutDelete(item);
            }
          }
        }) : _vm._e(), _vm._v(" "), _c('pendo-button', {
          staticClass: "select-layout",
          attrs: {
            "theme": "p2-light",
            "type": "secondary",
            "data-cy": "select-layout",
            "label": "Select Layout",
            "loading": item.selected
          },
          on: {
            "click": function ($event) {
              return select(item);
            }
          }
        })];
      }
    }, {
      key: "title",
      fn: function (ref) {
        var item = ref.item;
        return [_c('span', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', {
          staticClass: "layout-labels"
        }, [item.beta ? _c('pendo-tag', {
          attrs: {
            "size": "mini",
            "type": "beta",
            "round": "",
            "subtle": ""
          }
        }) : _vm._e(), _vm._v(" "), item.minSdkVersion ? _c('pendo-popover', {
          attrs: {
            "arrow": true,
            "placement": "bottom",
            "boundaries-element": "viewport",
            "popover-class": "min-sdk-layout--popover",
            "theme": "dark"
          }
        }, [_c('pendo-tag', {
          attrs: {
            "size": "mini",
            "type": "sdk",
            "label": "v",
            "round": "",
            "subtle": ""
          }
        }), _vm._v(" "), _c('template', {
          slot: "popover"
        }, [_c('div', {
          staticClass: "min-sdk-popper-container"
        }, [_c('div', {
          staticClass: "min-sdk-popper-title"
        }, [_c('strong', [_vm._v("SDK Version Requirement")])]), _vm._v(" "), _c('div', {
          staticClass: "{ min-sdk-popper-text: item.percentEligibleVisitors }"
        }, [_vm._v("\n                                Only visitors on applications with SDK " + _vm._s(item.minSdkVersion) + " or later will see guides with this layout.\n                            ")]), _vm._v(" "), item.percentEligibleVisitors ? _c('div', {
          staticClass: "min-sdk-popper-footer"
        }, [_c('strong', [_vm._v("\n                                    " + _vm._s(item.percentEligibleVisitors) + " of your users are on a compatible version.\n                                ")])]) : _vm._e()])])], 2) : _vm._e()], 1)];
      }
    }])
  }), _vm._v(" "), _vm.showDeleteLayoutModal ? [_c('pendo-modal', {
    attrs: {
      "visible": _vm.showDeleteLayoutModal,
      "confirm-button-config": {
        type: 'danger',
        label: 'Delete Layout'
      },
      "append-to-body": "",
      "type": "confirmation",
      "title": "Delete Layout?",
      "message": "You won't be able to recover it later. Are you sure you want to delete this layout?"
    },
    on: {
      "close": _vm.cancelDelete,
      "cancel": _vm.cancelDelete,
      "confirm": _vm.confirmDelete
    }
  })] : _vm._e()], 2);
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-layout-grid.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var PendoLayoutGrid = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

export default PendoLayoutGrid;
